export default {
  assumptionList: {
    method: 'post',
    url: '/costing/assumption/list'
  },
  assumptionDetail: {
    method: 'get',
    url: '/costing/assumption/detail/ID'
  },
  updateAssumption: {
    method: 'put',
    url: '/costing/assumption/update/ID'
  },
  createAssumption: {
    method: 'post',
    url: '/costing/assumption/create'
  },
  deleteAssumption: {
    method: 'DELETE',
    url: '/costing/assumption/delete/ID'
  }
}
